<section class="header__container" *ngIf="!isMobile">
  <div class="header__info">
    <div class="header__info--title truncate-text">{{ title }}</div>
    <div class="header__info--subtitle truncate-text" *ngIf="subtitle">
      {{ subtitle }}
    </div>
  </div>
  <div>
    <button
      mat-icon-button
      color="primary"
      aria-label="close modal"
      (click)="closeModal()"
    >
      <mat-icon class="icon">close</mat-icon>
    </button>
  </div>
</section>

<section class="header__container_mobile" *ngIf="isMobile">
  <div class="header__close__mobile">
    <button
      mat-icon-button
      color="primary"
      aria-label="close modal"
      (click)="closeModal()"
    >
      <mat-icon class="icon">close</mat-icon>
    </button>
  </div>

  <div class="header__info__mobile">
    <div class="header__info--title truncate-text">{{ title }}</div>
    <div class="header__info--subtitle truncate-text" *ngIf="subtitle">
      {{ subtitle }}
    </div>
    <div class="header__info--subtitle truncate-text" *ngIf="subtitleDoc">
      {{ subtitleDoc }}
    </div>
    <div class="header__info--subtitle truncate-text" *ngIf="subtitleReq">
      {{ subtitleReq }}
    </div>
  </div>
</section>
